var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPlayPrevious = function SvgPlayPrevious(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1762 4.40353C17.6473 4.18099 18.2389 4.01148 18.8258 4.32557C19.4126 4.63966 19.5997 5.22586 19.6759 5.74136C19.7501 6.24311 19.75 6.90591 19.75 7.67748V7.67752L19.75 7.73702V16.263L19.75 16.3225V16.3225C19.75 17.0941 19.7501 17.7569 19.6759 18.2586C19.5997 18.7741 19.4126 19.3603 18.8258 19.6744C18.2389 19.9885 17.6473 19.819 17.1762 19.5964C16.7175 19.3798 16.166 19.0121 15.5241 18.5841L15.4746 18.5511L9.08012 14.2881L9.03397 14.2574C8.50912 13.9075 8.04695 13.5995 7.72326 13.3069C7.37914 12.996 7.05278 12.581 7.05278 12C7.05278 11.4189 7.37914 11.004 7.72326 10.693C8.04694 10.4005 8.5091 10.0925 9.03393 9.74264L9.03396 9.74262L9.03397 9.74261L9.08013 9.71185L15.4746 5.44888L15.5241 5.41586C16.1661 4.98783 16.7175 4.62013 17.1762 4.40353ZM4.75 4.99993C4.75 4.58571 4.41421 4.24993 4 4.24993C3.58579 4.24993 3.25 4.58571 3.25 4.99993V18.9999C3.25 19.4141 3.58579 19.7499 4 19.7499C4.41421 19.7499 4.75 19.4141 4.75 18.9999L4.75 4.99993Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayPrevious);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Play - Previous.2a5db135821c67daefae5cacc75eb71a.svg";